module.exports = __webpack_public_path__ + "img/island-7983688_1280_thumb.03f2bf5f.jpg";